import { BrowserNames } from '@shared/all/domains/sessions';

import Android from './Android';
import Chrome from './Chrome';
import Edge from './Edge';
import Firefox from './Firefox';
import IOS from './IOS';
import Opera from './Opera';
import Safari from './Safari';
import Unknown from './Unknown';

export { Android, Chrome, Edge, Firefox, IOS, Opera, Safari, Unknown };

export const browserIconMap = {
  // Desktop browsers
  [BrowserNames.chrome]: Chrome,
  [BrowserNames.safari]: Safari,
  [BrowserNames.firefox]: Firefox,
  [BrowserNames.edge]: Edge,
  [BrowserNames.opera]: Opera,
  [BrowserNames.unknown]: Unknown,

  // Android
  [BrowserNames.androidApp]: Android,
  [BrowserNames.androidBrowserChrome]: Android,
  [BrowserNames.androidBrowserFirefox]: Android,
  [BrowserNames.androidBrowserSamsung]: Android,
  [BrowserNames.androidBrowserOpera]: Android,
  [BrowserNames.androidBrowserEdge]: Android,

  // iOS
  [BrowserNames.iosApp]: IOS,
  [BrowserNames.iosBrowserSafari]: IOS,
  [BrowserNames.iosBrowserChrome]: IOS,
  [BrowserNames.iosBrowserFirefox]: IOS,
  [BrowserNames.iosBrowserEdge]: IOS,

  // Oakbox. The platform icon rather than a mark of its own: this list answers
  // "what device is this?", and the browser column already carries the name.
  // The web client has no platform to name, so it takes the generic mark —
  // oakbox.me in Chrome is a browser session like any other.
  [BrowserNames.oakboxIos]: IOS,
  [BrowserNames.oakboxAndroid]: Android,
  [BrowserNames.oakboxWeb]: Unknown
};

export function getBrowserIcon(browserName: BrowserNames) {
  return browserIconMap[browserName] || Unknown;
}
